import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonFunctions } from 'src/app/shared/common-functions';
declare var dataLayer;
@Component({
  selector: 'app-add-card-dialog',
  templateUrl: './add-card-dialog.component.html',
  styleUrls: ['./add-card-dialog.component.scss']
})
export class AddCardDialogComponent implements OnInit {
  userType: string;
  userId: any;
  viewData: any;
  tierType: any;
  constructor(
    public dialogRef: MatDialogRef<AddCardDialogComponent>,
    private commonFunction: CommonFunctions
  ) {
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
   }
  ngOnInit(): void {
  }
  physicalCard(){
    this.dialogRef.close();
  }
  digitalCard(){
    this.dialogRef.close();
  }
  closeDialog(){
    this.dialogRef.close();
  }
  addCardClickGA(cardtype){
    dataLayer.push({
      'event': 'add_new_card_'+cardtype+'_click',
        'userID':this.userId ,
        'user_type':this.userType,
        'tier': this.tierType
    })  
  }
  crossBtnGA(){
    dataLayer.push({
      'event':'cross_click',
      'userID':this.userId,
      'user_type':this.userType,
      'tier':this.tierType
    })
  }
}